import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import NotificationService from 'core/services/notification';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'stores/store';

// components
import InactiveAccountComponent from '../components/inactiveAccount';
import ActiveAccountComponent from '../components/activeAccount';
import PageTitle from 'components/title/title';

// services
import { onGetDashboard } from '../services/dashboardService';

// models
import { DashboardStatistics } from '../models/AccountStatus';
import { getUserFromToken } from 'core/services/auth';
import { setAdmin } from 'stores/useAdminStore';
import { setCompany } from 'stores/useCompanyStore';

const DashboardPage: FunctionComponent = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const company = useSelector((state: RootState) => state.company);

	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [statistics, setStatistics] = useState<DashboardStatistics | null>(null);

	useEffect(() => {
		if (['Active', 'GeneralSuspended'].includes(company?.profile_status!) && company?.usage_start_at) {
			getDashboardStatistics();
		}
	}, []);

	const getDashboardStatistics = async () => {
		try {
			setIsLoading(true);
			const response = await onGetDashboard();
			setStatistics(response.statistics);
			setIsLoading(false);
		} catch (error) {
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.FETCH_ERROR'));
			setIsLoading(false);
		}
	};

	const onActivateHandler = async () => {
		getDashboardStatistics();

		const response = await getUserFromToken();
		dispatch(setAdmin(response.company_user));
		dispatch(setCompany(response.company_user.company));
	};

	return (
		<>
			<PageTitle name={t('TITLE.DASHBOARD')} />

			{['Active', 'GeneralSuspended'].includes(company?.profile_status!) && company?.usage_start_at ? (
				<ActiveAccountComponent isLoading={isLoading} statistics={statistics} />
			) : (
				<InactiveAccountComponent onActivateFinish={onActivateHandler} />
			)}
		</>
	);
};

export default DashboardPage;
